import { useNavigate } from "react-router-dom"
import { isTokenExpired } from "../libs/tokenUtils"
import { ChartBarIcon, CommandLineIcon, LockClosedIcon } from "@heroicons/react/24/outline"
import GlobalNavbar from "../components/GlobalNavbar"

const date = new Date()
const random = (Math.floor(date.getTime() / 1000) % 17) + 1
const year = date.getFullYear()

export default function Landing() {
  const navigate = useNavigate()
  const backgroundURL = `https://satudata.karanganyarkab.go.id//assets/img/background/karanganyar-${random}.jpg`

  const token = localStorage.getItem('token')
  const roleSlug = localStorage.getItem('user_role_slug')
  const isLoggedIn = !!(token && !isTokenExpired())
  const isAdmin = isLoggedIn && roleSlug !== 'user'

  return (
    <div 
      className="min-h-screen w-full flex flex-col justify-between pt-4 bg-cover bg-center relative font-sans text-sm"
      style={{ backgroundImage: `url(${backgroundURL})` }}
    >
      <div className="absolute inset-0 bg-black/75"></div>

      {/* Top Header */}
      <GlobalNavbar transparent={true} />

      {/* Main Hero Section */}
      <main className="relative flex items-center justify-center my-12 px-4 z-10">
        <div className="flex flex-col items-center gap-6 max-w-3xl text-center">
          <img src="/logo.png" alt="logo" className="size-24 sm:size-28" />
          
          <div className="space-y-2">
            <p className="text-2xl sm:text-3xl font-medium text-gray-200">
              Selamat datang di
            </p>
            <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight">
              API Profil Daerah Karanganyar
            </h1>
          </div>

          <form 
            onSubmit={(e) => {
              e.preventDefault()
              const formData = new FormData(e.currentTarget)
              const q = formData.get('q')
              navigate(`/dataset?q=${q || ''}`)
            }}
            className="mt-4 flex items-center w-full max-w-2xl bg-white/20 backdrop-blur-md rounded-full border border-white/30 p-1.5 shadow-2xl"
          >
            <input 
              name="q"
              type="text" 
              placeholder="Cari dataset (misal: jumlah penduduk...)" 
              className="flex-1 bg-transparent text-white placeholder-white/70 px-5 py-2.5 outline-none text-base"
            />
            <button 
              type="submit" 
              className="bg-primary-600 hover:bg-primary-700 text-white font-semibold py-2.5 px-7 rounded-full transition-colors shadow-md"
            >
              Cari
            </button>
          </form>
        </div>
      </main>

      {/* Feature Highlights */}
      <section className="relative text-white text-center flex flex-wrap justify-center items-start gap-10 px-6 my-8 z-10">
        <div className="flex flex-col items-center gap-3 max-w-xs">
          <div className="p-3 bg-white/10 rounded-2xl border border-white/10">
            <CommandLineIcon className="size-7" />
          </div>
          <h2 className="text-base font-bold">Dokumentasi API</h2>
          <p className="text-gray-300 text-xs leading-relaxed">
            Pelajari panduan lengkap penggunaan API dengan contoh dan referensi teknis.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3 max-w-xs">
          <div className="p-3 bg-white/10 rounded-2xl border border-white/10">
            <ChartBarIcon className="size-7" />
          </div>
          <h2 className="text-base font-bold">Data Publik</h2>
          <p className="text-gray-300 text-xs leading-relaxed">
            Akses data resmi terkait profil wilayah, demografi, serta potensi ekonomi Karanganyar.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3 max-w-xs">
          <div className="p-3 bg-white/10 rounded-2xl border border-white/10">
            <LockClosedIcon className="size-7" />
          </div>
          <h2 className="text-base font-bold">Keamanan Akses</h2>
          <p className="text-gray-300 text-xs leading-relaxed">
            Dilengkapi autentikasi dan enkripsi untuk memastikan akses API tetap aman dan andal.
          </p>
        </div>
      </section>

      {/* Bottom CTA & Footer */}
      <footer className="relative flex flex-col items-center gap-6 pb-6 z-10">
        <button 
          className="border border-white/80 bg-white/10 backdrop-blur-xs text-white font-semibold px-8 py-3 rounded-xl hover:bg-white hover:text-gray-900 transition-all"
          onClick={() => {
            if (isAdmin) navigate('/dashboard')
            else navigate('/dataset')
          }}
        >
          {isAdmin ? 'Buka Dashboard' : 'Mulai Jelajahi Dataset'}
        </button>

        <div className="text-xs text-gray-300">
          {`© ${year} DISKOMINFO Kabupaten Karanganyar`} 
        </div>
      </footer>
    </div>
  )
}
